import { get } from "lodash-es";

export default {
  methods: {
    async getFechaCompromiso(data, parametro1, parametro2) {
      if (data.length) {
        return data.sort((a, b) => {
          const fechaA = new Date(get(a, `[${parametro1}]`, ""));
          const fechaB = new Date(get(b, `[${parametro1}]`, ""));
          this.fechaCompromiso = fechaB - fechaA;
          return this.fechaCompromiso;
        })[0][parametro2];
      }
      return null;
    },
  },
  data: () => ({
    fechaCompromiso: "",
  }),
};
